module.exports = __webpack_public_path__ + "img/marketing.75198a82.svg";